// Fish only hides alkalinity, calcium, magnesium and phosphate, so their
// alerts stop: a tank whose Livestock still lists corals cannot switch to it
// (audit 2026-10-06, livestock first). Shared so Tank settings says it when
// the type is picked, before Save, in the server's own words (morning watch
// 2026-11-01: a keeper tapped Save three times in 9 s and was refused each
// time). Null when the change is not blocked.
export function coralsBlockTypeChange(toSlug, residents) {
  if (toSlug !== 'fowlr') return null;
  const corals = (Array.isArray(residents) ? residents : []).filter(
    (r) => r && r.kind === 'coral' && (r.status == null || r.status === 'in_tank')
  ).length;
  if (corals === 0) return null;
  return {
    code: 'corals_listed',
    error: `This tank still has ${corals === 1 ? 'a coral' : `${corals} corals`} in Livestock. Fish only would stop the alkalinity, calcium and magnesium alerts they need. Pick a coral type, or move or end the corals in Livestock first.`,
  };
}
